/**
 * Dependencies.
 */
import { ServicePointOrderDeliverModel } from '@/api/service-point/order-deliver/order-deliver.model';
import applicationConstant from '@/modules/main/constants/application.constant';
import { BaseService } from '@/modules/main/services/base.service';

/**
 * Service.
 */
class ServicePointOrderDeliverService extends BaseService<
ServicePointOrderDeliverModel
> {
  /**
   * Constructor.
   */
  constructor() {
    super(
      ServicePointOrderDeliverModel,
      ServicePointOrderDeliverModel.name,
      applicationConstant.apiServicePointPrivateUrl
    );
  }
}

/**
 * Export `servicePointOrderDeliverService`.
 */
export const servicePointOrderDeliverService = new ServicePointOrderDeliverService();
